import { BaseText, theme } from 'aimo-ui';
import React from 'react';
import styled from 'styled-components/native';

const Outline = styled.View`
  border: 1px solid ${theme.colors.black};
  border-radius: 4px;
  padding: 6px 10px;
  background-color: transparent;
`;

type WalletAddedBadgeProps = {
  label: string;
  testID: string;
};

const WalletAddedBadge = ({ label, testID }: WalletAddedBadgeProps) => (
  <Outline testID={testID}>
    <BaseText>{label}</BaseText>
  </Outline>
);

export default WalletAddedBadge;
